import React, { Component } from 'react';
import { translate } from '../../../../services';
import { showAccessoryForLanguage, showValueForLanguage, translateProperty } from '../../../../util';
import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';
import { EmptySearchStateIcon, NotSelectedRadioIconNew, SelectedRadioIconNew } from '../../../../../style/images';
import { combineDispatchers, flagDispatcher, flagState } from '../../../../store';
import { connect } from 'react-redux';

const Button = ( { onClick, text, value, variable, component } ) => {
  const click = () => onClick( variable, value, variable.fullyQualifiedName );
  return <button onClick={ click } >{component}</button>;
};

const GroupName = ( { name, onClick, title} ) => {
  const click = () => onClick( title );
  return <p onClick={ click }>{ name }</p>;
};

export class SearchResultsComponent extends Component {
  getTabName( name, groups = null ) {
    const { model } = this.props;
    let result;
    groups = groups || model.children;

    for( let group of groups ) {
      const groupName = translateProperty( group.properties, group.title );
      if( groupName === name ) {
        result = groupName;
        break;
      } else if ( group.hasChildren ) {
        const childResult = this.getTabName( name, group.children );
        result = childResult ? groupName : null;
      }
    }
    
    return result;
  }

  getFilteredGroups( groups ) {
    const { isPopup, searchString } = this.props;
    const lowerSearchString = searchString.toLowerCase();

    return groups.filter( group => {
      const title = translateProperty( group.properties, group.title ).toLowerCase();

      return group.show && !( group.title === 'Selector' && isPopup ) &&
             ( title.includes( lowerSearchString ) || this.getFilteredVariables( group.variables ).length > 0 || group.hasChildren && this.getFilteredGroups( group.children ) );
    } );
  }

  getFilteredVariables( variables ) {
    const { lang, searchString } = this.props;
    const lowerSearchString = searchString.toLowerCase();

    return variables.filter( variable => {
      const name = variable.name.toLowerCase();
      const title = translateProperty( variable.properties, variable.title ).toLowerCase();

      return showAccessoryForLanguage( lang )( variable ) && 
             variable.show && 
             ( name.includes( lowerSearchString ) || title.includes( lowerSearchString ) || this.getFilteredValues( variable.values ).length > 0 );
    } );
  }

  getFilteredValues( values ) {
    const { lang, searchString } = this.props;
    const lowerSearchString = searchString.toLowerCase();

    return values.filter( value => {
      const name = value.name.toLowerCase();
      const title = translateProperty( value.properties, value.title ).toLowerCase();
      let products = this.props.products
      let productsList = Object.values(products)
      const code = productsList?.filter((p)=>p && value.name===p.name && p.code?.includes(lowerSearchString))

      return showValueForLanguage( lang )( value ) && ( name.includes( lowerSearchString ) || title.includes( lowerSearchString ) || code?.length>0);
    } );
  }

  renderGroups( groups ) {
    const { goToGroup } = this.props;

    const groupsToRender = groups.map( ( group, key ) => {
      const name = translateProperty( group.properties, group.title );
      const variables = this.getFilteredVariables( group.variables );
      const subGroups = group.hasChildren && this.getFilteredGroups( group.children || [] );
      const header = React.createElement( `h${ subGroups && subGroups.length ? 2 : 3 }`, { onClick: () => goToGroup( this.getTabName( name ) ) }, name );
      
      return variables.length === 0 && !subGroups.length ? null : <div style={{height:"100%",width:"100%",overflow:"auto", padding: "0 20px 0 16px"}}><div key={ key } className="found-group">
        { header }
        { this.renderVariables( variables, group ) }
        { subGroups && subGroups.length && this.renderGroups( subGroups ) }
      </div></div>; 
    } );

    return groupsToRender.filter( group => group ).length
      ? groupsToRender 
      : this.renderNotFoundMessage();
  }

  goToGroup = title => this.props.goToGroup( this.getTabName( title ) )

  renderVariables( variables, group ) {
    const { lang } = this.props;
    const title = translateProperty( group.properties, group.title );

    return variables.map( ( variable, key ) => {
      const name = translateProperty( variable.properties, variable.title );
      const filteredValues = this.getFilteredValues( variable.values );
      const values = filteredValues.length > 0 ? filteredValues : variable.values.filter( showValueForLanguage( lang ) );

      return <div key={ key } className="found-variables">
        <GroupName name={ name } onClick={ this.goToGroup } title={ title } />
        { this.renderValues( values, variable ) }
      </div>;
    } );
  }

  renderValues( values, variable ) {
    const { assignValue, removeValue } = this.props;
    
    return values.map( ( value, key ) => {
      const name = translateProperty( value.properties, value.title );
      
      if(this.props.flags.callRemoveMethodForConfigurator && variable.title===this.props.flags.selectedVariable){
        removeValue(variable, value, variable.fullyQualifiedName)
        this.props.disableRemoveMethodForConfigurator()
      }
      return <div key={ key } className="found-variable">
        <span title={ name }>{ name }</span>
        { value.state === 0 && <Button onClick={ assignValue } value={ value } variable={ variable } component={<Box component="img" sx={{width:"16px",height:"16px"}} src={NotSelectedRadioIconNew}></Box>} >
        </Button> }
        { value.state === 1 && <Button onClick={ removeValue } value={ value } variable={ variable } component={<Box component="img" sx={{width:"16px",height:"16px"}} src={SelectedRadioIconNew}></Box>}>
        </Button> }
      </div>;
    } );
  }

  renderNotFoundMessage() {
    return <div style={{height:"100%", width:"100%", display:"flex", justifyContent:"center", alignItems:"center"}}>
      <div className='configurator-search-no-result-found'>
        <Box component="img" src={EmptySearchStateIcon} sx={{display:{xs:"flex", md:"none"},width:"60px", height:'60px', mb:"16px"}}></Box>
        <span className='no-result'>{ translate( 'No results found')}</span> 
        <span>{translate('Please try typing again')}</span>
      </div>
    </div>
     ;
  }

  render() {
    const { model, searchString } = this.props;

    const groups = this.getFilteredGroups( model.children );

    if( !searchString ) {
      return null;
    }

    if( !groups || !groups.length ) {
      this.renderNotFoundMessage();
    }

    return <div className="search-results">
      { this.renderGroups( groups ) }
    </div>;
  }
}

SearchResultsComponent.propTypes = {
  assignValue: PropTypes.func.isRequired,
  goToGroup: PropTypes.func.isRequired,
  isPopup: PropTypes.bool,
  lang: PropTypes.string.isRequired,
  model: PropTypes.shape( {
    children: PropTypes.array
  } ),
  removeValue: PropTypes.func.isRequired,
  searchString: PropTypes.string
};

export const SearchResults = connect(flagState,combineDispatchers(flagDispatcher))(SearchResultsComponent)